import { render, staticRenderFns } from "./ShapeLeft.vue?vue&type=template&id=70f2cbff"
import script from "./ShapeLeft.vue?vue&type=script&lang=js"
export * from "./ShapeLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports